import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { ClassProvider } from '@angular/core'

import { EncodeHttpParamsInterceptor } from '../interceptors/encode-http-params.interceptor'

export const ENCODE_HTTP_PARAMS_INTERCEPTOR: ClassProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: EncodeHttpParamsInterceptor,
  multi: true,
}
